$(document).ready(function () {
    //   $('.cst-variant-url').click(function(){
    //    var variant_url = $(this).attr('product-url');
    //     window.location.href= variant_url;

    // });
        $('.my-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: false,
        responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
      });
    $('.mega-menu').on('mouseenter', function() {
      $(this).attr('open', true);
    });
    
    $('.mega-menu').on('mouseleave', function() {
      $(this).removeAttr('open');
    });

    setTimeout(function () {
      $(".cst-variant-url:nth-of-type(1)").trigger("click");
    }, 50);
  
    $(".cst-variant-url").click(function () {
        var test = $(this).attr("option-name");
        console.log(test);

        setTimeout(function () {
            $(".product__media-list li").each(function () {
                var listItem = $(this);
                var listItemSlide = listItem.attr("alt");

                if (test == listItemSlide) {
                    listItem.css("display", "block");
                } else {
                    listItem.css("display", "none");
                }
            });
        }, 50);
    });
});
